export default __webpack_public_path__ + "static/icon-adjustable-straps-d39d36ade5f5ce2ef2a5ded5bf788d0e.webp";